import { defineStore } from 'pinia'
//import { parse, stringify } from 'zipson'

export const useMyStore = defineStore('store', () => {
    const ultimoLogin = reactive({
      Email: ''
    })

    const dadosLogin = reactive({
      Id: '',
      Email: '',
      NomeUsuario: '',
      Perfil: '',
      Jwt: '',
    })
  
    function guardarLogin(dadosLogin) {
      this.dadosLogin.Id = dadosLogin.Id
      this.dadosLogin.Email = dadosLogin.Email
      this.dadosLogin.NomeUsuario = dadosLogin.NomeUsuario
      this.dadosLogin.Perfil = dadosLogin.Perfil
      this.dadosLogin.Jwt = dadosLogin.Jwt

      //guarda último e-mail de login para facilitar o preenchimento do campo.
      this.ultimoLogin.Email = dadosLogin.Email
    }

    function limparLogin() {
      this.dadosLogin.Id = ''
      this.dadosLogin.Email = ''
      this.dadosLogin.NomeUsuario = ''
      this.dadosLogin.Perfil = ''
      this.dadosLogin.Jwt = ''
    }

    const estaLogado = computed(() => 
      dadosLogin != null
      && dadosLogin.Jwt != null
      && dadosLogin.Jwt != ''
    )

    const ultimaPesquisaRespondente = reactive({
      pesquisa: null,
      dataHora: null
    })

    function guardarUltimaPesquisaRespondente(pesquisa) {
      this.ultimaPesquisaRespondente.pesquisa = pesquisa
      this.ultimaPesquisaRespondente.dataHora = Date.now()
    }

    return {
      dadosLogin, guardarLogin, limparLogin, estaLogado, ultimoLogin,
      guardarUltimaPesquisaRespondente, ultimaPesquisaRespondente
    }
},
{
  persist: {
      storage: persistedState.localStorage,
      /*serializer: {
        deserialize: parse,
        serialize: stringify
      }*/
  },

})
